

/* @ngInject */
export default function GEOStateSelectController($rootScope, $scope, $state, $location, $stateParams, $timeout, geoStateCacheService, categoryCacheService, productFilterService) {
    const vm = this;
    vm.selectedState = '';
    vm.selectedStateOptions = [];

    // Wait until Categories & Geo States are set
    $scope.$on('productCenter.setupComplete', () => {
        init();
    });

    init();

    // Dynamically set State Options
    $rootScope.$on('productCenter.setupComplete', () => {


    });

    vm.switchState = function (i) {
        vm.selectedState = vm.stateSelectOptions[i];

        categoryCacheService.clearCategories();

        productFilterService.clearFilterDTOs();

        $location.search('filters', '');

        $state.go('product-lookup', {
            GeoState: vm.selectedState.StateAbbreviation,
        }, {
            notify: true,
        } );
    };


    function init() {
        vm.stateSelectOptions = geoStateCacheService.getGeoStates();
        vm.selectedState = geoStateCacheService.getGeoStateObject($stateParams.GeoState);

        // Filter out ineligible states
        if ($scope.filterList && $scope.filterList.length > 0) {
            const geoStates = [];

            for (let i = 0; i < $scope.filterList.length; i++) {
                for (let j = 0; j < vm.stateSelectOptions.length; j++) {
                    if ($scope.filterList[i] === vm.stateSelectOptions[j].StateAbbreviation) {
                        geoStates.push(vm.stateSelectOptions[j]);
                    }
                }
            }

            vm.stateSelectOptions = geoStates;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/productCenter/pages/_shared/geoStateSelect/geoStateSelect.controller.js